import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GenerateTemplatesDialoagComponent } from './gennerate-template-dialoag/generate-template.component';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ToolbarServiceService } from 'src/app/layout/components/toolbar/toolbar-service.service';
import { ToastrService } from 'ngx-toastr';
import { TierPermissionPipe } from '@_pipes/tier-permission.pipe';
import { TimersService } from '@_services/timers.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  providers: [TierPermissionPipe],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatesComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() systemSettingCallback: any;
  @Output() saveSettingData = new EventEmitter<any>();
  getTemplateArray: any = [];
  SubsSiteSharePoint: any = [];
  getDropDownValue: any = [];
  currentDocType: any = 'None';
  flexData: any = '300px';
  DocRegData: any = [];
  abc: any;
  a: string;
  isAutoOpen: boolean = false;
  isAutoOpen1: boolean = false;
  class: boolean;
  sub: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  sub7: Subscription;
  public isspiner: boolean = false;
  MatterDropData: any;
  currentUSer: any = JSON.parse(localStorage.getItem('currentUser'));
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    public dialog: MatDialog,
    public tierpermission: TierPermissionPipe,
    private behaviorService: BehaviorService,
    public toolbarServiceService: ToolbarServiceService,
    private toastr: ToastrService,
    private Timersservice: TimersService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingTemplatesComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.sub = this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data: any) => {
        this.class = data;
        this.cd.markForCheck();
      });
    this.getDropValue();
    // this.sub1 = this._mainAPiServiceService.getSetData({ EXCLUDESYSTEMACCOUNTS: true, EXCLUDEINVOICETEMPLATESETTINGS: true }, 'GetSystem').subscribe(response => {
    //   // this.currentDocType = response['DATA']['SYSTEM']['DOCUMENTGROUP']['DOCUMENTSYSTEM'] ? response['DATA']['SYSTEM']['DOCUMENTGROUP']['DOCUMENTSYSTEM'] : this.currentDocType;
    //   this.getDropDownValue = response.DATA.LISTS;
    // });
    this.loadData();
  }

  getDropValue() {
    let userList: any = JSON.parse(localStorage.getItem('users_list'));
    if (userList && userList != null) {
      this.MatterDropData = this.Timersservice.removeUSerWithoutId(userList);
    } else {
      let d: any = {};
      this.sub7 = this.Timersservice.GetUsers(d)
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (response: any) => {
            if (response.CODE == 200 && response.STATUS == 'success') {
              this.MatterDropData = this.Timersservice.removeUSerWithoutId(response.DATA.USERS);
              localStorage.setItem('users_list', JSON.stringify(response.DATA.USERS));
              this.cd.markForCheck();
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
    }
  }

  /**
   * load the data of templates
   */
  loadData() {
    // this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: { GroupName: 'Templates' } }, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.isLoadingResults = false;
            this.getDropDownValue = response.DATA.LISTS;
            let tempData: any = response.DATA.RECORDS;
            this.currentUSer.DONTGENERATERECEIPT = tempData.DONTGENERATERECEIPT;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUSer));
            //localStorage.setItem('DONTGENERATERECEIPT',tempData.DONTGENERATERECEIPT);
            this.SettingForm.controls['INVOICETEMPLATE'].setValue(tempData.INVOICETEMPLATE);
            this.SettingForm.controls['INVOICESAVEFOLDERLOCATION'].setValue(
              tempData.INVOICESAVEFOLDERLOCATION,
            );
            this.SettingForm.controls['RECEIPTSAVEFOLDERLOCATION'].setValue(
              tempData.RECEIPTSAVEFOLDERLOCATION,
            );
            this.SettingForm.controls['INVOICESAVEFOLDERPARENT'].setValue(
              tempData.INVOICESAVEFOLDERPARENT.toString(),
            );
            this.SettingForm.controls['RECEIPTSAVEFOLDERPARENT'].setValue(
              tempData.RECEIPTSAVEFOLDERPARENT.toString(),
            );
            this.SettingForm.controls['RECEIPTTEMPLATE'].setValue(tempData.RECEIPTTEMPLATE);
            this.SettingForm.controls['DONTGENERATERECEIPT'].setValue(tempData.DONTGENERATERECEIPT);
            this.SettingForm.controls['DEFAULTSUBFOLDERS'].setValue(tempData.DEFAULTSUBFOLDERS);
            this.SettingForm.controls['DIRECTORYSAVESTRATEGY'].setValue(
              tempData.DIRECTORYSAVESTRATEGY.toString(),
            );
            this.SettingForm.controls['DOCUMENTSYSTEM'].setValue(
              tempData.DOCUMENTSYSTEM.toString(),
            );
            this.SettingForm.controls['SHAREPOINTSITE'].setValue(
              tempData.SHAREPOINTSITE.toString(),
            );
            this.SettingForm.controls['SHAREPOINTSUBSITE'].setValue(
              tempData.SHAREPOINTSUBSITE.toString(),
            );
            this.SettingForm.controls['ROOTFOLDER'].setValue(tempData.ROOTFOLDER.toString());
            this.SettingForm.controls['SHAREPOINTDRIVE'].setValue(
              tempData.SHAREPOINTDRIVE.toString(),
            );
            // this.SettingForm.controls['TEMPLATEFOLDER'].setValue(tempData.TEMPLATEFOLDER.toString());
            this.SettingForm.controls['DOCUMENTSAVESTRATEGY'].setValue(
              tempData.DOCUMENTSAVESTRATEGY.toString(),
            );
            this.SettingForm.controls['TRACKDOCUMENTS'].setValue(tempData.TRACKDOCUMENTS);
            this.SettingForm.controls['ONEDRIVEPRIMARYUSER'].setValue(tempData.ONEDRIVEPRIMARYUSER);
            this.SettingForm.controls['SIGNATUREUSERGUID'].setValue(tempData.SIGNATUREUSERGUID);
            this.SettingForm.controls['NETDOCSCABINETNAME'].setValue(tempData.NETDOCSCABINETNAME);
            this.SettingForm.controls['NETDOCSCLIENTATTRIBUTE'].setValue(
              tempData.NETDOCSCLIENTATTRIBUTE,
            );
            this.SettingForm.controls['NETDOCSMATTERATTRIBUTE'].setValue(
              tempData.NETDOCSMATTERATTRIBUTE,
            );
            this.SettingForm.controls['IMANAGELIBRARYNAME'].setValue(tempData.IMANAGELIBRARYNAME);
            this.SettingForm.controls['DEFAULTUPLOADFOLDER'].setValue(tempData.DEFAULTUPLOADFOLDER);
            this.currentDocType = tempData.DOCUMENTSYSTEM
              ? tempData.DOCUMENTSYSTEM
              : this.currentDocType;
            this.behaviorService.loadingSystemSetting('templete');
            this.OnchnageofDocument({ value: this.currentDocType });
            // this.SettingForm.controls['XEROSTARTDATE'].setValue(tempData.XEROSTARTDATE);
            // let XEROStartDateArray = tempData.XEROSTARTDATE.split("/");
            // this.SettingForm.controls['XEROSTARTTEXTDATE'].setValue(new Date(XEROStartDateArray[1] + '/' + XEROStartDateArray[0] + '/' + XEROStartDateArray[2]));
            this.cd.markForCheck();
          }
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the particular selected template
   */
  saveTemplate() {
    this.isspiner = true;
    let data: any = {
      GroupName: 'Templates',
      DOCUMENTSYSTEM: this.SettingForm.controls['DOCUMENTSYSTEM'].value,
      SHAREPOINTSITE: this.SettingForm.controls['SHAREPOINTSITE'].value,
      SHAREPOINTSUBSITE: this.SettingForm.controls['SHAREPOINTSUBSITE'].value,
      SHAREPOINTDRIVE: this.SettingForm.controls['SHAREPOINTDRIVE'].value,
      ONEDRIVEPRIMARYUSER: this.SettingForm.controls['ONEDRIVEPRIMARYUSER'].value,
      ROOTFOLDER: this.SettingForm.controls['ROOTFOLDER'].value,
      DIRECTORYSAVESTRATEGY: this.SettingForm.controls['DIRECTORYSAVESTRATEGY'].value,
      DOCUMENTSAVESTRATEGY: this.SettingForm.controls['DOCUMENTSAVESTRATEGY'].value,
      SAVEDOCUMENTS: 0,
      DEFAULTSUBFOLDERS: this.SettingForm.controls['DEFAULTSUBFOLDERS'].value,
      INVOICETEMPLATE: this.SettingForm.controls['INVOICETEMPLATE'].value,
      INVOICESAVEFOLDERPARENT: this.SettingForm.controls['INVOICESAVEFOLDERPARENT'].value,
      INVOICESAVEFOLDERLOCATION: this.SettingForm.controls['INVOICESAVEFOLDERLOCATION'].value,
      RECEIPTTEMPLATE: this.SettingForm.controls['RECEIPTTEMPLATE'].value,
      RECEIPTSAVEFOLDERPARENT: this.SettingForm.controls['RECEIPTSAVEFOLDERPARENT'].value,
      RECEIPTSAVEFOLDERLOCATION: this.SettingForm.controls['RECEIPTSAVEFOLDERLOCATION'].value,
      DONTGENERATERECEIPT: this.SettingForm.controls['DONTGENERATERECEIPT'].value,
      SIGNATUREUSERGUID: this.SettingForm.controls['SIGNATUREUSERGUID'].value,
      NETDOCSCABINETNAME: this.SettingForm.controls['NETDOCSCABINETNAME'].value,
      NETDOCSCLIENTATTRIBUTE: this.SettingForm.controls['NETDOCSCLIENTATTRIBUTE'].value,
      NETDOCSMATTERATTRIBUTE: this.SettingForm.controls['NETDOCSMATTERATTRIBUTE'].value,
      IMANAGELIBRARYNAME: this.SettingForm.controls['IMANAGELIBRARYNAME'].value,
      DEFAULTUPLOADFOLDER: this.SettingForm.controls['DEFAULTUPLOADFOLDER'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.currentUSer.DONTGENERATERECEIPT =
              this.SettingForm.controls['DONTGENERATERECEIPT'].value;
            this.currentUSer.DOCUMENTSYSTEM = this.SettingForm.controls['DOCUMENTSYSTEM'].value;
            this.behaviorService.setDOCUMENTSYSTEM$.next(
              this.SettingForm.controls['DOCUMENTSYSTEM'].value,
            );
            localStorage.setItem('currentUser', JSON.stringify(this.currentUSer));
            // localStorage.setItem('DONTGENERATERECEIPT',this.SettingForm.controls.DONTGENERATERECEIPT.value);
            this.isspiner = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub2?.unsubscribe();
    this.sub7?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to On change the Documnet data
   */
  OnchnageofDocument(ob: any) {
    this.currentDocType = ob.value;
    let tempError: any = [];
    let tempWarning: any = [];
    if (this.currentDocType == 'Dropbox') {
      this.flexData = '1200px';
      tempWarning['ROOTFOLDER'] = {};
    } else if (this.currentDocType == 'GoogleDrive-Not Supported') {
      this.flexData = '1200px';
    } else if (this.currentDocType == 'OneDrive') {
      this.flexData = '600px';
      tempWarning['ONEDRIVEPRIMARYUSER'] = {};
      tempWarning['ROOTFOLDER'] = {};
    } else if (this.currentDocType == 'Sharepoint') {
      this.flexData = '300px';
      let matter: any = JSON.parse(localStorage.getItem('set_active_matters'));
      // let data1 = { FormAction: "update", VALIDATEONLY: false, FILETYPE: "SUBSITES", MATTERGUID: matter.MATTERGUID }
      // this.sub2 = this._mainAPiServiceService.getSetData(data1, 'NetDriveGetDocument').subscribe(response => {
      let data1: any = {
        Action: 'NetDriveGetDocument',
        Data: {
          FILETYPE: 'SUBSITES',
          MATTERGUID: matter.MATTERGUID,
        },
      };
      this._mainAPiServiceService
        .getSetData(data1, 'cloud-storage')
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (response: any) => {
            if (response.CODE == 200 && response.STATUS === 'success') {
              this.SubsSiteSharePoint = response.DATA.DOCUMENTS;
            } else if (response.MESSAGE == 'Not logged in') {
            }
            this.cd.markForCheck();
            // this.isGenrateReport = false;
          },
          error: (error: any) => {
            // this.isGenrateReport = false;
          },
        });
      this.flexData = '300px';
      tempError['SHAREPOINTSITE'] = {};
    } else {
      this.flexData = '300px';
    }
    this.errorWarningData = { Error: tempError, Warning: tempWarning };
    this.cd.markForCheck();
  }
  whichFolder(data: any) {
    this.SettingForm.controls['RECEIPTSAVEFOLDERPARENT'].setValue(data.value);
    this.cd.markForCheck();
  }
  whichFolderInvoice(data: any) {
    this.SettingForm.controls['INVOICESAVEFOLDERPARENT'].setValue(data.value);
    this.cd.markForCheck();
  }

  SelectDocument() {
    this.isAutoOpen = true;
    const dialogRef = this.dialog.open(GenerateTemplatesDialoagComponent, {
      disableClose: true,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
      data: { action: 'new' },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.isAutoOpen = false;
      if (result) {
        this.SettingForm.controls['INVOICETEMPLATE'].setValue(
          `${result.FOLDERPATH}${result.TEMPLATENAME}`,
        );
        // this.SettingForm.controls['INVOICETEMPLATE'].setValue(result.TEMPLATENAME);
      }
      this.cd.markForCheck();
    });
  }
  SelectReceiptDocument() {
    this.isAutoOpen1 = true;
    const dialogRef = this.dialog.open(GenerateTemplatesDialoagComponent, {
      disableClose: true,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
      data: { action: 'new' },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.isAutoOpen1 = false;
      if (result) {
        this.SettingForm.controls['RECEIPTTEMPLATE'].setValue(
          `${result.FOLDERPATH}${result.TEMPLATENAME}`,
        );
        // this.SettingForm.controls['RECEIPTTEMPLATE'].setValue(result.TEMPLATENAME);
      }
      this.cd.markForCheck();
    });
  }

  async refreshField() {
    await this.saveSettingData.emit(true);
  }

  manageTemplates(event: any) {
    this.toolbarServiceService.generateDocumentsFromMatters(event, 'system-setting-template');
  }

  ConnectToSharePoint() {
    let connectText: string;
    if (this.currentDocType == 'GoogleDrive-Not Supported') {
      connectText = 'Google';
    } else {
      connectText = this.currentDocType;
    }
    // let CONNECTURL = `${environment.APIEndpoint}OAuth2Start?AuthType=${connectText}&SessionToken=${this.currentUSer.SessionToken}`;
    // var win = window.open(CONNECTURL, 'targetWindow',
    //     `toolbar=no,
    //   location=no,
    //   status=no,
    //   menubar=no,
    //   scrollbars=yes,
    //   resizable=yes,
    //   width=800,
    //   height=600`);
    let payload: any = {
      Action: 'OAuth2Start',
      VALIDATEONLY: false,
      Data: {
        USERGUID: this.currentUSer.UserGuid,
        AuthType: connectText,
      },
    };
    this._mainAPiServiceService
      .getSetData(payload, 'oauth-connections')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            window.open(
              response.DATA[0].AuthorizationUrl,
              'targetWindow',
              `toolbar=no,
                    location=no,
                    status=no,
                    menubar=no,
                    scrollbars=yes,
                    resizable=yes,
                    width=800,
                    height=600,
                    noopener,noreferrer`,
            );
          }
          this.cd.markForCheck();
        },
      });
  }
}
